<template>
  <div class="flex flex-wrap items-end justify-between gap-4 mb-6">
    <div>
      <h2 class="text-xl font-semibold text-secondary-800">{{ title }}</h2>
      <div v-if="subtitle || $slots.subtitle" class="text-sm text-secondary-500 mt-1"><slot name="subtitle">{{ subtitle }}</slot></div>
    </div>
    <div class="flex flex-wrap items-center gap-2"><slot /></div>
  </div>
</template>

<script>
// Page heading in the sales-dashboard style (see sales_budget.vue).
export default {
  name: "SoPageHead",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
  },
};
</script>
